import { Typography } from '@material-ui/core';
import BackgroundBlurImage from 'components/Shared/BackgroundBlurImage';
import { ReactNode, SyntheticEvent } from 'react';

import makeStyles from '@material-ui/core/styles/makeStyles';

interface IClasses {
  root: string;
  label: string;
  image: string;
}
interface IProps {
  id: number;
  src: string;
  onError: () => void;
  onClick: (event?: SyntheticEvent) => void;
  style?: React.CSSProperties;
  title?: string;
  children?: ReactNode;
  backdrop?: ReactNode;
  classes?: Partial<IClasses>;
}

const useStyles = makeStyles((theme) => ({
  image: {
    '@media(max-width: 1024px)': {
      minHeight: 124,
    },
    position: 'relative',
    paddingTop: '68.33%',
  },
  root: {
    position: 'relative',
    background: theme.palette.dark[600],
    overflow: 'hidden',
    borderRadius: 8,
    width: '18.7vw',
    maxWidth: 610,
    '@media(max-width: 1024px)': {
      width: 181,
      maxWidth: 181,
    },
  },
  label: {
    '@media(max-width: 1440px)': {
      padding: theme.spacing(2),
    },
    maxHeight: 200,
    overflow: 'hidden',
    borderTop: `1px solid ${theme.defaultTheme.main_palette.main}`,
    padding: theme.spacing(4),
    background: theme.palette.dark[600],
    '& > span': {
      '@media(max-width: 1440px)': {
        fontSize: 14,
      },
      fontWeight: 700,
      color: theme.palette.common.white,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'normal',
      display: '-webkit-box',
      overflowWrap: 'break-word',
      '-webkit-line-clamp': 4,
      '-webkit-box-orient': 'vertical',
    },
  },
  title: {
    '-webkit-line-clamp': '1 !important',
  },
}));

const Card = (props: IProps) => {
  const classes = useStyles();

  return (
    <div id='showcase-card' className={[props?.classes?.root, classes.root].join(' ')}>
      <div className={[props?.classes?.image, classes.image].join(' ')} onClick={props.onClick} style={props?.style}>
        <BackgroundBlurImage src={props.src} onError={props.onError} alt={props.title} />
        <div className='status'>{props.backdrop}</div>
      </div>
      <div className={[classes.label, props?.classes?.label].join(' ')}>
        {!props?.children && props?.title && (
          <Typography className={classes.title} component='span' id='showcase-card-title'>
            {props.title}
          </Typography>
        )}
        {props?.children}
      </div>
    </div>
  );
};

export default Card;
